"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrlExternal = void 0;
const getHostFromUrl = (url) => {
    return new URL(url).hostname.replace("www.", "");
};
const isAbsoluteUrl = (url) => {
    const formatedUrl = url.toLowerCase();
    return formatedUrl.startsWith("http") || formatedUrl.startsWith("https");
};
const isUrlExternal = (url, host) => {
    if (isAbsoluteUrl(url)) {
        const providedHost = getHostFromUrl(url);
        return providedHost !== host;
    }
    else {
        return false;
    }
};
exports.isUrlExternal = isUrlExternal;
//# sourceMappingURL=index.js.map